import { Button, Fade, Tooltip, useTheme } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";

export const ButtonTertiaryIcon = ({
  onClick,
  disabled,
  startIcon,
  endIcon,
  children,
  sx,
  id,
  tooltip,
  "aria-label": ariaLabel,
}: IButtons) => {
  const theme = useTheme();
  const button = (
    <Button
      id={id}
      // variant="text"
      onClick={onClick}
      disabled={disabled}
      disableRipple
      aria-label={ariaLabel}
      sx={{
        color: theme.palette.systemSecondary01,
        height: "2rem",
        minWidth: "unset !important",
        opacity: disabled ? 0.3 : 1,
        lineHeight: "1.5rem",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: "0.75rem",
        fontStyle: "normal",
        padding: "0.5rem 0.5rem",
        "&:hover": {
          backgroundColor: "transparent",
          color: theme.palette.text.primary,
        },
        //TODO da finire i vari stati (active, focus)
        ...sx,
      }}
      endIcon={endIcon}
      startIcon={startIcon}
    >
      {children}
    </Button>
  );

  return tooltip ? (
    <Tooltip title={tooltip} TransitionComponent={Fade}>
      {button}
    </Tooltip>
  ) : (
    button
  );
};
